import leftTemplate from "./leftController";
import rightTemplate from "./rightController";

/**
 * Create method
 */
const createTemplate = (element) => {
    const leftContent = createLeftContent(element);
    const rightContent = createRightContent(element);
    const documentsContent = createDocumentsContent(element);
    const accessoriesContent = createAccessoriesContent(element);
    const popupModalContent = createPopupModalContent(element);
    return `
        <div class="configurator-wrapper">
            <section class="configurator__contentarea configurator_contents">
                ${leftContent}
                ${rightContent}
            </section>
            <!-- Documents -->
            ${documentsContent}
            <!-- Accessories -->
            ${accessoriesContent}
            <!-- Popup modal -->
            ${popupModalContent}
        <div>
        `;
}

const createLeftContent = (element) => {
    const productImageTemplate = leftTemplate.imageSection(element);
    const productSummaryTemplate = leftTemplate.summarySection(element);
    const productCTATemplate = leftTemplate.ctaSection(element);

    return `
    <div class="configurator_summary configurator__section">
        <!-- Product image -->
        <div class="configurator">
            ${productImageTemplate}
        </div>

        <!-- New: configuratore summary list -->
        <div class="configurator_summary__list">
            ${productSummaryTemplate}
        </div>

        <!-- CTA + product feature list  -->
        <div class="cta_controller">
            ${productCTATemplate}
        </div>
    </div>
    `;

}

const createRightContent = (element) => {
    console.log('createRightContent');
    let productDetailTemplate = rightTemplate.contentProductDetailSection(element);
    let allTemplate = rightTemplate.contentAllSection();
    return `
    <div class="configurator_controllers">

        <div class="product_details">
           ${productDetailTemplate}
        </div>

        ${allTemplate[1].outerHTML}
        ${allTemplate[2].outerHTML}

    </div>
    `;
}

//const createRightContent = (element) => {
//    console.log('createRightContent');
//    const productDetailTemplate = rightTemplate.contentProductDetailSection(element);
//    const orderTypeTemplate = rightTemplate.contentOrderTypeSection(element);
//    const patientNameTemplate = rightTemplate.contentPatientNameSection(element);
//    const powerLevelTemplate = rightTemplate.contentPowerLevelSection(element);
//    const chargerTemplate = rightTemplate.contentChargerSection(element);
//    const colorTemplate = rightTemplate.contentColorSection(element);
//    const audiogramTemplate = rightTemplate.contentAudiogramSection(element);
//    const optionsTemplate = rightTemplate.contentOptionsSection(element);
//    const impressionsTemplate = rightTemplate.contentImpressionsSection(element);
//    const warrantyTemplate = rightTemplate.contentWarrantySection(element);
//    const specialInstructionsTemplate = rightTemplate.contentSpecialInstructionsSection(element);
//    return `
//    <div class="configurator_controllers">

//        <div class="product_details">
//           ${productDetailTemplate}
//        </div>

//        <!-- Order type -->
//        <section>
//            ${orderTypeTemplate}
//        </section>

//        <!-- Patient name -->
//        <section>
//            ${patientNameTemplate}
//        </section>

//        <!-- Power level -->
//        <section>
//            ${powerLevelTemplate}
//        </section>
        
//        <!-- Charger -->
//        <section>
//            ${chargerTemplate}
//        </section>

//        <!-- Color -->
//        <section>
//            ${colorTemplate}
//        </section>
        
//        <!-- Audiogram -->
//        <section>
//            ${audiogramTemplate}
//        </section>

//        <!-- Options -->
//        <section>
//            ${optionsTemplate}
//        </section>

//        <!-- Impressions -->
//        <section>
//            ${impressionsTemplate}
//        </section>

//        <!-- Warranty -->
//        <section>
//            ${warrantyTemplate}
//        </section>
        
//        <!-- Special intructions -->
//        <section>
//            ${specialInstructionsTemplate}
//        </section>
//    </div>
//    `;
//}

// TODO
const createDocumentsContent = (element) => {
    return ``;
}

// TODO
const createAccessoriesContent = (element) => {
    return ``;
}

/**
 * Popup modal template
 * @param {Element} element 
 * @returns { String }
 */
const createPopupModalContent = (element) => {
    const dialogElement = element.querySelector('.configurator_modal');
    return dialogElement ? dialogElement.outerHTML : '';
}

export { createTemplate };